import { Protocol } from '../Protocol';

export class CarbonEmissionProtocol {
  public static readonly CARBON_EMISSION_HEADER: string = `${Protocol.YATUNG_API_ROOT}/projectInfo/carbonEmissionInfo/ttl`;
  public static readonly PAGEABLE_CARBON_EMISSION_BY_SEARCH: string = `${Protocol.YATUNG_API_ROOT}/projectInfo/carbonEmissionInfo/order/pageable`;
}
